export const PredefinedStackNames = {
    Home: 'sportshomestack',
    NonSportsProduct: 'non-sports-stack',
};
